export type AppleAuthMode = 'popup' | 'redirect';

/** Chooses the OAuth interaction that is most reliable for the current browser. */
export function resolveAppleAuthMode(): AppleAuthMode {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return 'popup';

  try {
    const userAgent = navigator.userAgent?.toLowerCase() ?? '';
    const isMobile = /android|iphone|ipad|ipod|mobile/.test(userAgent);
    const isHeadless = /headless|electron|karma|playwright|chromeheadless/.test(userAgent);
    const isEmbedded = window.top !== window.self;
    return isMobile || (isEmbedded && !isHeadless) ? 'redirect' : 'popup';
  } catch {
    return 'popup';
  }
}

export function isApplePopupBlocked(error: unknown): boolean {
  return getFirebaseErrorCode(error) === 'auth/popup-blocked';
}

export function getFirebaseErrorCode(error: unknown): string {
  if (typeof error !== 'object' || error === null || !('code' in error)) return '';
  return String(error.code);
}
